import { decodeOrThrow } from 'src/utils/decoding';

interface Config {
  API_HOST: string;
  API_PORT?: number;
  API_BASE_PATH?: string;
  API_BASE_PATH_V2?: string;
  API_PROTOCOL: 'http' | 'https';
  NODE_ENV: 'development' | 'test' | 'production';
  APP_ENV: string;
}

const validateConfig = (payload: unknown): Config | null => {
  if (
    typeof payload === 'object' &&
    payload !== null &&
    typeof (payload as any).API_HOST === 'string' &&
    typeof (payload as any).API_PROTOCOL === 'string' &&
    ['http', 'https'].includes((payload as any).API_PROTOCOL) &&
    typeof (payload as any).NODE_ENV === 'string' &&
    ['development', 'test', 'production'].includes((payload as any).NODE_ENV) &&
    typeof (payload as any).APP_ENV === 'string'
  ) {
    return {
      API_HOST: (payload as any).API_HOST,
      API_PORT: payload.hasOwnProperty('API_PORT') ? Number((payload as any).API_PORT) : undefined,
      API_BASE_PATH: (payload as any).API_BASE_PATH,
      API_BASE_PATH_V2: (payload as any).API_BASE_PATH_V2,
      API_PROTOCOL: (payload as any).API_PROTOCOL as 'http' | 'https',
      NODE_ENV: (payload as any).NODE_ENV as 'development' | 'test' | 'production',
      APP_ENV: (payload as any).APP_ENV,
    };
  }

  return null;
};

export const config = decodeOrThrow(validateConfig, {
  NODE_ENV: process.env.NODE_ENV, // this is the build context JS env defined by react
  APP_ENV: process.env.REACT_APP_ENV, // this is the app environment which is defined in .env.* files
  API_HOST: process.env.REACT_APP_API_HOST,
  API_PROTOCOL: process.env.REACT_APP_API_PROTOCOL,
  API_PORT: process.env.REACT_APP_API_PORT,
  API_BASE_PATH: process.env.REACT_APP_API_BASE_PATH,
  API_BASE_PATH_V2: process.env.REACT_APP_API_BASE_PATH_V2,
});
